import api from "../utils/axios";

export const getPlans = async (params = {}) => {
  try {
    const {
      page = 1,
      limit = 10,
      search = "",
      sortBy = "name",
      sortOrder = "asc",
    } = params;
    const response = await api.get(`/plans/admin`, {
      params: {
        page,
        limit,
        search,
        sortBy,
        sortOrder,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updatePlan = async (planId, planData) => {
  try {
    const response = await api.put(`/plans/${planId}`, planData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const deletePlan = async (planId) => {
  try {
    const response = await api.delete(`/plans/${planId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const createPlan = async (planData) => {
  try {
    const response = await api.post("/plans", planData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getPublicPlans = async () => {
  try {
    const response = await api.get("/plans");
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
